export default "__VITE_ASSET__BovdYILC__"